import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { TaskRoutinePage } from '~/features/routines/task-routine-page';

function TaskRoute(): ReactElement {
  const { recordId, ruleId } = Route.useParams();
  return <TaskRoutinePage key={`${recordId}:${ruleId}`} recordId={recordId} ruleId={ruleId} />;
}

/** A task rule, on its own page (docs/plans/routines.md R6). */
export const Route = createFileRoute('/_app/routines/task/$recordId/$ruleId')({
  component: TaskRoute,
});
